import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useMenuConfig = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.MENU_CONFIG(),
    queryFn: () => shopApi.fetchMenuConfig(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.MENU_CONFIG(),
    });
  };

  return {
    isLoading,
    isFetching,
    menuConfig: data?.data,
    invalidate,
  };
};
